import React, { lazy, Suspense } from 'react';

const LazyWarrantyClaimDetail = lazy(() => import('./WarrantyClaimDetail'));

const WarrantyClaimDetail = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyWarrantyClaimDetail {...props} />
  </Suspense>
);

export default WarrantyClaimDetail;
